import { useTranslation } from '@pancakeswap/localization'
import { Currency } from '@pancakeswap/sdk'
import { Typography } from '@/components/ui/typography'
import { ArrowRightLeftIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function RateToggle({
  currencyA,
  handleRateToggle,
}: {
  currencyA?: Currency | null
  handleRateToggle: () => void
}) {
  const { t } = useTranslation()

  return currencyA ? (
    <div className={'flex justify-center items-center gap-2'}>
      <Typography variant={'small'}>{t('View prices in')}</Typography>
      <Button size={'sm'} variant="outline" onClick={handleRateToggle}>
        <ArrowRightLeftIcon className={'size-4'} />
        {currencyA?.symbol}
      </Button>
    </div>
  ) : null
}
